import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { MessagingInboxComponent } from './components/inbox/inbox.component';
import { TalkService } from './services/talk.service';

@NgModule({
  declarations: [MessagingInboxComponent],
  imports: [CommonModule],
  exports: [MessagingInboxComponent],
  providers: [TalkService],
})
export class MessagingModule {}
